import React from 'react';

import { Button } from '@dexma/ui-components';
import i18n from 'asset/translation';
import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { reportsPath } from 'adapter/in/common/routes';
import { ActionButtons, HeaderRow, TitleCell } from 'adapter/in/reports/components/commonHeaderStyles/commonHeaderStyles';
import { StyledSpanAsHeading } from 'adapter/in/common/components/Home/style';

type GeneratePDFOverlayHeaderProps = {
    reportInstanceId: string;
    onCancel: () => void;
};
const GeneratePDFOverlayHeader = (props: GeneratePDFOverlayHeaderProps) => {
    const { reportInstanceId, onCancel } = props;
    const { navigationPush } = useNavigation();

    return (
        <>
            <HeaderRow>
                <Button
                    kind='iconButton'
                    data-testid='link-go-back'
                    iconAfter='arrow_left'
                    variant='icon-secondary'
                    isCircle
                    onClick={() => navigationPush(`instance/${reportInstanceId}`, reportsPath)}
                    iconAriaLabel={`${i18n.t('common.back')}}`}
                />
                <TitleCell>
                    <StyledSpanAsHeading type='h1' text='Generate PDF' style={{ margin: '0' }} />
                </TitleCell>
                <ActionButtons>
                    <Button
                        data-testid='submit'
                        text='Cancel'
                        variant='primary'
                        type='button'
                        onClick={() => {
                            onCancel();
                        }}
                    />
                </ActionButtons>
            </HeaderRow>
        </>
    );
};

export default GeneratePDFOverlayHeader;
